import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './CreativeChartHeader.css';
import { Dropdown } from '../../../components/widgets';
import ToggleTabGroup from '../../../components/atoms/ToggleTabGroup';
import TopXChartDataFilter from '../../../components/partials/TopXChartDataFilter';

const CreativeChartHeader = ({
    title,
    selectedOption,
    onOptionChanged,
    dropdownOptions = [],
    tabs = [],
    selectedTab,
    onTabChange,
    onTopXChanged,
    showTopX = false,
    selectedTopX = 5,
    rowDataLength = 0,
    isTopXDisabled = false,
}) => {

    const toggleTabOptions = tabs.map(tab => ({
        option: tab.value,
        label: tab.label,
    }));

    const handleTabToggle = optionValue => {
        const clickedTab = tabs.find(tab => tab.value === optionValue);
        if (clickedTab) onTabChange(clickedTab);
    };

    return (
        <div className={css.header}>
            <div className={css.titleSection}>
                <span className={css.title}>
                    <Translate id={title} />
                </span>
            </div>
            <div className={css.controls}>
                {!!tabs.length && (
                    <ToggleTabGroup
                        options={toggleTabOptions}
                        selectedOption={selectedTab?.value}
                        onToggle={handleTabToggle}
                    />
                )}
                {!!dropdownOptions.length && (
                    <Dropdown
                        selected={selectedOption}
                        onSelection={onOptionChanged}
                        items={dropdownOptions}
                        containerClass={css.dropdown}
                        selectedContainer={css.selectedDropdown}
                        bodyClassName={css.dropdownBody}
                    />
                )}
                {showTopX && (
                    <TopXChartDataFilter
                        topXCount={selectedTopX}
                        rowDataLength={rowDataLength}
                        onChange={onTopXChanged}
                        withShowAll
                        className={css.topXWrapper}
                        labelClassName={css.topXLabel}
                        dropdownClassName={css.topXDropdown}
                        disabled={isTopXDisabled}
                    />
                )}
            </div>
        </div>
    );
};

CreativeChartHeader.propTypes = {
    title: PropTypes.string,
    selectedOption: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }),
    onOptionChanged: PropTypes.func,
    dropdownOptions: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ),
    tabs: PropTypes.array,
    selectedTab: PropTypes.object,
    onTabChange: PropTypes.func,
    showTopX: PropTypes.bool,
    selectedTopX: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onTopXChanged: PropTypes.func,
    rowDataLength: PropTypes.number,
    isTopXDisabled: PropTypes.bool,
};

export default CreativeChartHeader;
